import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function InvestorRelations() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('investorRelations.title')}
      subtitle={t('investorRelations.subtitle')}
    >
      <h2>{t('investorRelations.ownership')}</h2>
      <p>{t('investorRelations.ownershipCopy')}</p>

      <h2>{t('investorRelations.growth')}</h2>
      <p>{t('investorRelations.growthCopy')}</p>

      <h2>{t('investorRelations.prospective')}</h2>
      <p>
        {t('investorRelations.prospectiveCopyBefore')}{' '}
        <Link to="/investor-connect">{t('investorRelations.prospectiveLink')}</Link>{' '}
        {t('investorRelations.prospectiveCopyAfter')}
      </p>
    </InfoPage>
  );
}
